import { authRequest } from "~/utils/api";

/**
 * @param {string} token
 * @returns {Promise<Array>} tag_groups
 */
export const getTagGroups = (token) =>
  authRequest(token, { url: "/tag_groups" }).then(
    (res) => res.data?.tag_groups || []
  );
